import React from "react";
import { EditAdminContextProvider } from "./EditAdminView";
import EditAdminPage from "./views/EditAdminPage";

const EditAdmin = () => {
  return (
    <div>
      <EditAdminContextProvider>
        <EditAdminPage />
      </EditAdminContextProvider>
    </div>
  );
};

export default EditAdmin;
